<section class="bolt-container">
    <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg"
        *ngIf="(paymentState === PaymentStateEnum.LOADING || paymentAccount === PaymentAccountEnum.LOADING) && !isUnregisteredUser">
        Loading payment information...
    </bolt-waiting-indicator>
        <bolt-notification type="info" *ngIf="isUnregisteredUser"
            class="bolt-space-bottom-lg">
            <a class="bolt-link"
                href="{{environment.NATIONWIDE.MY_ACCOUNT_LOGIN}}"
                rel="noopener">Log in</a> to see this information.
        </bolt-notification>
        <div
            *ngIf="!(paymentState === PaymentStateEnum.LOADING || paymentAccount === PaymentAccountEnum.LOADING || paymentState === PaymentStateEnum.ERROR || paymentAccount === PaymentAccountEnum.ERROR) && !isUnregisteredUser">
            <div class="bolt-row bolt-justify-content-between">
                <div class="bolt-col-8 bolt-space-bottom-lg">
                    <div class="bolt-heading-md">Payments</div>
                </div>
                <div class="bolt-col-md-auto bolt-space-bottom-lg">
                    <bolt-button width="full-md"
                        iconleft="gear"
                        (click)="openPaymentPreferences()">Payment preferences</bolt-button>
                </div>
            </div>
            <div id="paymentPreferencesModal">
                <is-payment-preferences (closeAction)="onPaymentPreferencesClose($event)"></is-payment-preferences>
            </div>
            <div *ngIf="!isPaymentsNotApplicable">
                <p class="bolt-body-copy-lg bolt-space-bottom-lg"
                    *ngIf="paymentAccount === PaymentAccountEnum.HAS_BANK_ACCOUNT && paymentState === PaymentStateEnum.HAS_PAYMENTS">
                    When you receive a payment, you'll find it
                    listed
                    here.
                    We have your {{ bankAccountDetails?.bankName }} {{ bankAccountDetails?.bankAccountType }} account on file to
                    send
                    EFT payments.</p>
                <p class="bolt-body-copy-lg bolt-space-bottom-lg"
                    *ngIf="paymentAccount === PaymentAccountEnum.NO_BANK_ACCOUNT">When a payment is issued, you'll find it
                    listed
                    here.
                    Since you don't have a bank account on file, you'll get a check in the mail.</p>
                <div #paymentDetailsMobile
                    class="mobile-only tile-stack bolt-space-bottom-sm"
                    *ngIf="paymentState === PaymentStateEnum.HAS_PAYMENTS">
                    <div *ngFor="let info of paymentsSummary.displayInfo"
                        class="payment-card bolt-space-bottom-lg">
                        <div class="bolt-body-copy-lg "><strong>Payment to {{ info.issueTo }}</strong></div>
                        <div class="bolt-body-copy-md "><strong>Issue date:</strong> {{ info.issueDate }}</div>
                        <div class="bolt-body-copy-md "><strong>Payment amount:</strong> {{ info.amount }}</div>
                        <div class="bolt-body-copy-md "
                            *ngIf="info.description"><strong>Note:</strong> {{ info.description }}</div>
                        <div class="bolt-body-copy-md "><strong>Status:</strong> {{ info.status }}</div>
                        <div class="bolt-body-copy-md "><strong>Type:</strong> {{ info.type }}</div>
                        <div class="bolt-body-copy-md "><strong>Reference number:</strong> {{ info.referenceNumber }}</div>
                    </div>
                    <bolt-page-navigator class="nav-alignment"
                        id="pageNav"
                        *ngIf="totalPages > 1"
                        [spread]="2"
                        [current]="currentPage"
                        [total]="totalPages"
                        (bolt-goto)="gotoPage($event)"></bolt-page-navigator>
                </div>

                <div #paymentDetailsDesktop
                    class="desktop-only bolt-table bolt-table-fit-content bolt-table-striped bolt-space-bottom-lg bolt-table-vibrantBlue "
                    *ngIf="paymentState === PaymentStateEnum.HAS_PAYMENTS">
                    <table>
                        <thead>
                            <tr>
                                <th>Issue date</th>
                                <th>Amount</th>
                                <th>Issued to</th>
                                <th>Status</th>
                                <th>Type</th>
                                <th>Reference number</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let info of paymentsSummary.displayInfo">
                                <td class="norap-col">
                                    {{ info.issueDate }}
                                </td>
                                <td>
                                    <bolt-row>{{ info.amount }}</bolt-row>
                                    <div class="bolt-space-bottom-2xs"></div>
                                    <bolt-row *ngIf="info.description">{{ info.description }}</bolt-row>
                                </td>
                                <td>{{ info.issueTo }}</td>
                                <td>{{ info.status }}</td>
                                <td>{{ info.type }}</td>
                                <td>{{ info.referenceNumber }}</td>

                            </tr>
                        </tbody>
                    </table>

                    <bolt-page-navigator id="pageNav"
                        class="nav-alignment"
                        *ngIf="totalPages > 1"
                        [spread]="5"
                        [current]="currentPage"
                        [total]="totalPages"
                        (bolt-goto)="gotoPage($event)"></bolt-page-navigator>

                </div>
                <p *ngIf="paymentState === PaymentStateEnum.NO_PAYMENTS && paymentAccount === PaymentAccountEnum.HAS_BANK_ACCOUNT"
                    class="bolt-body-copy-lg bolt-space-bottom-lg">No payments have been made on this
                    claim.
                </p>
                <div>
                    <p class="bolt-heading-sm bolt-space-bottom-lg">For faster payment</p>
                    <p class="bolt-body-copy-lg bolt-space-bottom-lg">Ask your claims professional about having payments
                        deposited
                        directly into your checking or savings.</p>
                    <p class="bolt-body-copy-lg bolt-space-bottom-lg">You might not be able to if:</p>
                    <ul class="bolt-space-bottom-lg">
                        <li class="bolt-body-copy-lg">A contractor is paid directly</li>
                        <li class="bolt-body-copy-lg">More than one party is being paid (you, contractor, mortgage holder)
                        </li>
                    </ul>
                    <p class="bolt-heading-sm bolt-space-bottom-lg">Injury-related payments</p>
                    <p class="bolt-body-copy-lg bolt-space-bottom-lg">If injuries were involved, ask your claims
                        professional
                        how
                        those payments are handled. To protect your privacy, we don't display injury-related information
                        online.
                    </p>
                </div>
            </div>
            <bolt-notification class="bolt-space-bottom-2xl"
                *ngIf="isPaymentsNotApplicable"
                type="warning">
                We are unable to make a payment on this claim. Talk to your claims professional for more information.
            </bolt-notification>

        </div>

        <bolt-notification class="bolt-space-bottom-lg"
            type="error"
            *ngIf="(paymentState === PaymentStateEnum.ERROR || paymentAccount === PaymentAccountEnum.ERROR)&& !isUnregisteredUser">
            Your payments didn't load. We'll get it fixed.
        </bolt-notification>
</section>
